import React from "react";

const CIRCULAR_CHECKBOX_CLASS = `
  h-4 w-4 shrink-0 cursor-pointer appearance-none rounded-full
  border border-greyscale-3 bg-white
  checked:border-primary
  checked:bg-primary
  checked:shadow-[inset_0_0_0_3px_white]
  focus-visible:outline-none
  focus-visible:ring-2
  focus-visible:ring-primary
  focus-visible:ring-offset-2
  disabled:cursor-not-allowed
  disabled:opacity-50
`;

export default function CircularCheckbox({
  className = "",
  type = "checkbox",
  ...props
}) {
  return (
    <input
      type={type}
      className={`${CIRCULAR_CHECKBOX_CLASS} ${className}`.trim()}
      {...props}
    />
  );
}
